import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'diameter',
  title: 'Wheel Diameters',
  type: 'document',
  orderings: [
    {
      title: 'Wheel Diameter, Desc',
      name: 'wheelDiameterDesc',
      by: [{field: 'wheelDiameter', direction: 'desc'}],
    },
    {
      title: 'Name A-Z',
      name: 'nameAsc',
      by: [{field: 'name', direction: 'asc'}],
    },
  ],
  fields: [
    defineField({
      name: 'wheelDiameter',
      title: 'Wheel Diameter',
      description: 'The diameter of the wheel in inches',
      type: 'number',
      validation: (Rule) => Rule.required().positive().integer(),
    }),
    defineField({
      name: 'name',
      title: 'Name (legacy)',
      description: 'This field will be removed once migration is done',
      readOnly: true,
      type: 'string',
      validation: (Rule) => Rule.required(),
    }),
    defineField({
      name: 'slug',
      title: 'Slug (legacy)',
      description:
        'Wheel diameter does not have dedicated page on the frontend. We are using this slug to generate URLs for the gallery pages filter ie. `?diameter=18`. This field will be removed once migration is done',
      readOnly: true,
      type: 'slug',
      validation: (Rule) => Rule.required(),
      options: {
        source: 'name',
        maxLength: 50,
      },
    }),
  ],
  preview: {
    select: {
      name: 'name',
      wheelDiameter: 'wheelDiameter',
    },
    prepare({ name, wheelDiameter }) {
      return {
        title: name || `${wheelDiameter}"`,
      }
    },
  },
})
